var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isProvided
    ? _c(
        "dynamic-rate",
        [
          _c("rate", {
            attrs: {
              "is-available": _vm.isAvailable,
              value: _vm.formattedValue,
              "is-selected": _vm.isSelected,
              toggle: _vm.toggleRate,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }